import { useState } from "react";

export function useItemRequestsModals() {
  const [createRequestModal, setCreateRequestModal] = useState(false);
  const [requestDetailModal, setRequestDetailModal] = useState<number | null>(null);
  const [fulfillModal, setFulfillModal] = useState<number | null>(null);
  const [rejectReasonModal, setRejectReasonModal] = useState<number | null>(null);
  const [markUnavailableModal, setMarkUnavailableModal] = useState<number | null>(null);

  return {
    createRequestModal,
    setCreateRequestModal,
    requestDetailModal,
    setRequestDetailModal,
    fulfillModal,
    setFulfillModal,
    rejectReasonModal,
    setRejectReasonModal,
    markUnavailableModal,
    setMarkUnavailableModal,
  };
}
